import { reactive } from 'vue'

interface Estado {
  visible: boolean
  saludo: string
  nombre: string
  subtitulo: string
}

// Singleton: la animación vive en App.vue para sobrevivir al cambio de ruta.
// El login la muestra y navega por debajo; se retira cuando pasó el tiempo
// mínimo y la página de destino ya está montada.
const estado = reactive<Estado>({ visible: false, saludo: '', nombre: '', subtitulo: '' })

const MAX_MS = 2500
let desde = 0
let timer: number | null = null

function minimoMs(): number {
  const reducido = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  return reducido ? 450 : 1000
}

function saludoPorHora(d = new Date()): string {
  const h = d.getHours()
  return h < 12 ? 'Buenos días' : h < 19 ? 'Buenas tardes' : 'Buenas noches'
}

function programar(ms: number) {
  if (timer !== null) window.clearTimeout(timer)
  timer = window.setTimeout(ocultar, ms)
}

function ocultar() {
  if (timer !== null) window.clearTimeout(timer)
  timer = null
  estado.visible = false
}

/**
 *   const bienvenida = useBienvenida()
 *   bienvenida.mostrar(user.nombre_completo, 'Abriendo el punto de venta…')
 *   await router.replace(destino)
 *   bienvenida.listo()
 */
export function useBienvenida() {
  function mostrar(nombreCompleto: string, subtitulo: string) {
    estado.saludo = saludoPorHora()
    estado.nombre = nombreCompleto.trim().split(/\s+/)[0] || nombreCompleto
    estado.subtitulo = subtitulo
    estado.visible = true
    desde = performance.now()
    // Por si la navegación nunca avisa: no dejar la pantalla tapada.
    programar(MAX_MS)
  }

  /** La ruta de destino ya cargó: se retira al cumplir el tiempo mínimo. */
  function listo() {
    if (!estado.visible) return
    programar(Math.max(0, minimoMs() - (performance.now() - desde)))
  }

  return { estado, mostrar, listo, ocultar }
}
